import { AlertDialogBody as ChakraAlertDialogBody, ModalBodyProps as ChakraModalBodyProps } from '@chakra-ui/react';
import { bodyFont } from 'constants/theme';

const AlertDialogBody = (props: ChakraModalBodyProps) => (
  // Workaround for styles not supported
  <ChakraAlertDialogBody fontFamily={bodyFont} {...props} />
);

export { AlertDialogBody };
